import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { Breakpoint } from "react-socks"

import { Button } from "../inputs"
import { H2, YekanParagraph } from "../typography"
import { FoldText, FoldOverflow, FoldButton } from "./styled"
import { colors } from "../../utils/styleVariables"

class RenderComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      opened: false,
    }
  }

  handleExpand() {
    this.setState({ opened: !this.state.opened })
  }

  render() {
    const { copy, description, more, less } = this.props

    return (
      <>
        <FoldText
          direction="vertical"
          halign="center"
          style={{ marginTop: "0 !important" }}
        >
          <FoldOverflow opened={this.state.opened}>
            <H2>{copy}</H2>
            <YekanParagraph dangerouslySetInnerHTML={{ __html: description }} />
          </FoldOverflow>
          <Breakpoint mobile down>
            <FoldButton>
              <div className="transparent" />
              <Button
                text={this.state.opened ? less : more}
                backgroundColor={colors.white}
                shadowColor={[0, 0, 0, 0.16]}
                maxWidth="200px"
                handleClick={() => this.handleExpand.bind(this)}
              />
            </FoldButton>
          </Breakpoint>
        </FoldText>
      </>
    )
  }
}

const PricingFold = () => (
  <StaticQuery
    query={graphql`
      {
        yaml: contentYaml(header: { slug: { eq: "/hamdeli" } }) {
          content {
            copy
            description
            more
            less
          }
        }
      }
    `}
    render={data => <RenderComponent {...data.yaml.content} />}
  />
)

export default PricingFold
